import SiteEnum from '@models/enums/SiteEnum';
import { IMediaHero } from '@models/IHero';
import SharedMediaHero from '@organisms/MediaHero/MediaHero';

const MediaHero = (props: IMediaHero) => (
  <SharedMediaHero {...props} site={SiteEnum.B2B} />
);

export default MediaHero;
